<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1ClDHK/tc-custom/9781595553836.jpg?1726273280663" alt="This image is the cover for the book Defiant Joy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Defiant Joy
      </h1>
      <p class="bookDescription body article font2">
        <p></p><p>You may be aware that G. K. Chesterton authored influential Christian biographies and apologetics. But you may not know the larger-than-life Gilbert Keith Chesterton himself—not yet. Equally versed in poetry, novels, literary criticism, and journalism, he addressed politics, culture, and religion with a towering intellect and a soaring wit. </p><p>Chesterton engaged his world through the written word. He carried on lively, public discussions with the social commentators of his day, continually challenging them with civility, humility, erudition, and his ever-sharp sense of humor. Today’s reader can find the same treasures, for as Chesterton said, “What a man can believe depends upon his philosophy, not upon the clock or the century.”</p><p>In Kevin Belmonte’s fresh new biography, you’ll get to know the real G. K. Chesterton and his literary and cultured accomplishments. A giant of his time, Chesterton continues to live large in the imaginations of twenty-first-century readers.</p><p><b>Endorsements:</b></p><p><b>“Chesterton’s explanation of Christianity makes absolute sense of the world. He reminds us that, free of our comforting delusions, reality is a tragic adventure in which we get to participate.” —DONALD MILLER, author of the <i>New York Times</i> bestsellers <i>A Million Miles in a Thousand Years</i> and <i>Blue Like Jazz</i></b></p><p><b>“Bravo to Kevin Belmonte for turning his caring attention to the incomparably hilarious and brilliant genius that is G.K. Chesterton!” —ERIC METAXAS, <i>New York Times</i> best-selling author of <i>Bonhoeffer: Pastor, Martyr, Prophet, Spy</i> and </b><i><b>Amazing Grace: William Wilberforce and the Heroic Campaign to End Slavery</b></i></p><p><b><b>“There’s a great new biography about one of the Christian giants of the 20th Century. And I mean that literally. </b><b>To read Kevin Belmonte's recent book <i>Defiant Joy: The Remarkable Life &amp; Impact of G. K. Chesterton</i>, is to feel a powerful sense of longing . . . because there is such a longing, a great need for advocates like Chesterton in our day. . . . But let's be grateful we still have the works of that great man to study and learn from. . . And we also have for you have Belmonte's vibrant new biography -- a wonderful reminder of the magnificent example Chesterton has set for us.”</b></b><b><b><b>—CHUCK COLSON(http://patriotpost.us/opinion/chuck-colson/2012/01/26/defiant-joy-why-we-still-need-chesterton/)</b></b></b><b></b></p><p></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kevin Belmonte
      </h2>
      
      <p class="authorDescription body article"><P>Kevin Belmonte&#160;holds a BA in English Literature and&#160;two MA's in Church History and American and New England studies. He is the author of several books including&#160;<I>William Wilberforce: A Hero for Humanity</I>&#160;and winner of the prestigious John Pollock Award for Christian Biography</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?25639595